import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

const base = 'inline-flex min-h-[48px] items-center justify-center gap-2 rounded-full px-6 text-[15px] font-semibold transition-[transform,box-shadow,background-color] duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-2 disabled:opacity-60';

const Cmp = ({ to, href, children, className, ...props }) => {
  if (to) return <Link to={to} className={className} {...props}>{children}</Link>;
  if (href) return <a href={href} className={className} {...props}>{children}</a>;
  return <button type="button" className={className} {...props}>{children}</button>;
};

export const PrimaryButton = ({ children, className = '', arrow = false, ...props }) => (
  <Cmp className={`${base} bg-accent text-accent-foreground shadow-[0_1px_2px_rgba(37,99,235,0.3),0_8px_24px_-8px_rgba(37,99,235,0.5)] hover:-translate-y-0.5 hover:bg-[#1D4ED8] ${className}`} {...props}>
    {children}{arrow && <ArrowRight className="h-4 w-4" aria-hidden="true" />}
  </Cmp>
);

export const SecondaryButton = ({ children, className = '', ...props }) => (
  <Cmp className={`${base} border border-border bg-white text-primary hover:-translate-y-0.5 hover:border-primary/30 hover:shadow-sm ${className}`} {...props}>{children}</Cmp>
);

export const DarkButton = ({ children, className = '', ...props }) => (
  <Cmp className={`${base} bg-primary text-primary-foreground hover:-translate-y-0.5 hover:shadow-md ${className}`} {...props}>{children}</Cmp>
);
